import jss from 'jss';

const styles = {
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '15px 5px'
  },
  table: {
    width: '100%',
    height: '100%'
  },
  icon: {
    width: '1.5em',
    textAlign: 'center',
    display: 'inline-block'
  }
};

export const { classes } = jss.createStyleSheet(styles).attach();



// WEBPACK FOOTER //
// ./src/views/comm/styles/table.js